<!--接受两个属性-->
<!--一个是 form-item: 这样不需要设置 top 且会自动跟父元素的 el-form-item 保持水平-->
<!--另一个是 top: 上一个属性是 true，则是跟 el-form-item 的微调，若 false 则是跟 el-form-item 的 top 偏移-->

<!--需要放在 el-form-item 元素内使用-->

<template>
  <div
    class="qm-description"
    :class="{'form-item': formItem, slim: slim}"
    :style="computedStyle"
  >
    <img
      src="/static/icon/icon-notice-info.svg"
      :style="{visibility: noIcon ? 'hidden' : 'visible'}"
      class="qm-description-icon"
      alt
    />
    <div class="qm-description-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'QmDescription',
  props: {
    formItem: Boolean,
    slim: Boolean,
    top: {
      type: String,
      default: '',
    },
    noIcon: Boolean,
  },
  computed: {
    computedStyle() {
      if (!this.top) {
        return {}
      } else {
        return {
          top: `${this.top}px`,
        }
      }
    },
  },
}
</script>

<style scoped></style>
